import {
  AssessmentEvaluationReducer,
  AuthReducer,
  ConfigReducer,
  ExperimentsReducer,
  FirebaseReducer,
  HistogramReducer,
  IterableReducer,
  LanguageReducer,
  ProgressReducer,
  StatsReducer,
} from '@web_opxp/features';
import { combineReducers } from 'redux';
import { AchievementsReducer } from '../achievements';
import * as AppReducer from '../app/slice';
import * as AssessmentReducer from '../assessment/slice';
import * as BridgeReducer from '../bridge/slice';
import { CyclesReducer } from '../cycles';
import { EvaluationReducer } from '../evaluation';
import { ExerciseReducer } from '../exercise';
import * as ExercisesReducer from '../exercises/slice';
import { FeedbackReducer } from '../feedback';
import { GroupReducer } from '../groupAdmin';
import { HighscoresReducer } from '../highscores';
import { SessionReducer } from '../session';
import { SubscriptionReducer } from '../subscription';
import { SuccessPredictorReducer } from '../successPredictor';
import * as TrainingIntensityReducer from '../trainingIntensity/slice';
import { UnityReducer } from '../unity';

export default combineReducers({
  [AppReducer.statePropName]: AppReducer.default,
  [AuthReducer.statePropName]: AuthReducer.default,
  [CyclesReducer.statePropName]: CyclesReducer.default,
  [HistogramReducer.statePropName]: HistogramReducer.default,
  [ProgressReducer.statePropName]: ProgressReducer.default,
  [SessionReducer.statePropName]: SessionReducer.default,
  [ConfigReducer.statePropName]: ConfigReducer.default,
  [StatsReducer.statePropName]: StatsReducer.default,
  [ExerciseReducer.statePropName]: ExerciseReducer.default,
  [UnityReducer.statePropName]: UnityReducer.default,
  [LanguageReducer.statePropName]: LanguageReducer.default,
  [ExercisesReducer.statePropName]: ExercisesReducer.default,
  [HighscoresReducer.statePropName]: HighscoresReducer.default,
  [EvaluationReducer.statePropName]: EvaluationReducer.default,
  [AssessmentReducer.statePropName]: AssessmentReducer.default,
  [FirebaseReducer.statePropName]: FirebaseReducer.default,
  [BridgeReducer.statePropName]: BridgeReducer.default,
  [AchievementsReducer.statePropName]: AchievementsReducer.default,
  [SuccessPredictorReducer.statePropName]: SuccessPredictorReducer.default,
  [FeedbackReducer.statePropName]: FeedbackReducer.default,
  [ExperimentsReducer.statePropName]: ExperimentsReducer.default,
  [GroupReducer.statePropName]: GroupReducer.default,
  [SubscriptionReducer.statePropName]: SubscriptionReducer.default,
  [AssessmentEvaluationReducer.statePropName]: AssessmentEvaluationReducer.default,
  [IterableReducer.statePropName]: IterableReducer.default,
  [TrainingIntensityReducer.statePropName]: TrainingIntensityReducer.default,
});
